import React from 'react';
import PropTypes from 'prop-types';

const STEPS = [
  { id: 1, label: 'Recipient' },
  { id: 2, label: 'Amount' },
  { id: 3, label: 'Review' },
];

function getStepLabelClass(stepId, activeStep) {
  if (activeStep === stepId) return 'text-[var(--n900)]';
  if (activeStep > stepId) return 'text-[var(--n600)]';
  return 'text-[var(--n400)]';
}

function SendMoneyStepper({ currentStep }) {
  return (
    <div className='flex flex-col gap-2.5'>
      <div className='flex gap-1.5'>
        {STEPS.map((step) => (
          <div
            key={step.id}
            className={`h-[3px] flex-1 rounded-sm transition-colors ${currentStep >= step.id ? 'bg-[var(--n900)]' : 'bg-[var(--n400)]'}`}
          />
        ))}
      </div>
      <div className='flex gap-1.5'>
        {STEPS.map((step) => (
          <div
            key={step.id}
            className={`flex-1 text-[10.5px] font-semibold uppercase tracking-[0.12em] font-[family-name:var(--font-ui)] ${getStepLabelClass(step.id, currentStep)}`}
          >
            {String(step.id).padStart(2, '0')} · {step.label}
          </div>
        ))}
      </div>
    </div>
  );
}

SendMoneyStepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default SendMoneyStepper;
